<template>
  <div class="container">
    <div class="notice-list flex-between">
      <div
        class="notice-item"
        :class="{
          'can-view': isZbCanView,
          active: noticeType === noticeTypeMap.ZBGG,
        }"
        @click="isZbCanView && selectNoticeType(noticeTypeMap.ZBGG)"
      >
        <img
          v-if="noticeType === '1'"
          class="notice-img"
          src="@/assets/images/xmxx/招标公告1.png"
          alt=""
        />
        <img
          v-else-if="isZbCanView"
          class="notice-img"
          src="@/assets/images/xmxx/招标公告2.png"
          alt=""
        />
        <img
          v-else
          class="notice-img"
          src="@/assets/images/xmxx/招标公告3.png"
          alt=""
        />
        <span>采购公告</span>
      </div>
      <div
        class="notice-item cs-fb"
        :class="{
          'can-view': isCqCanView,
          active: noticeType === noticeTypeMap.BGGG,
        }"
        @click="isCqCanView && selectNoticeType(noticeTypeMap.BGGG)"
      >
        <img
          v-if="noticeType === '2'"
          class="notice-img"
          src="@/assets/images/xmxx/澄清变更公告1.png"
          alt=""
        />
        <img
          v-else-if="isCqCanView"
          class="notice-img"
          src="@/assets/images/xmxx/澄清变更公告2.png"
          alt=""
        />
        <img
          v-else
          class="notice-img"
          src="@/assets/images/xmxx/澄清变更公告3.png"
          alt=""
        />
        <span>澄清/变更公告</span>
      </div>
      <div
        class="notice-item"
        :class="{
          'can-view': isHxCanView,
          active: noticeType === noticeTypeMap.ZBHXRGS,
        }"
        @click="isHxCanView && selectNoticeType(noticeTypeMap.ZBHXRGS)"
      >
        <img
          v-if="noticeType === '3'"
          class="notice-img"
          src="@/assets/images/xmxx/中标候选人公示1.png"
          alt=""
        />
        <img
          v-else-if="isHxCanView"
          class="notice-img"
          src="@/assets/images/xmxx/中标候选人公示2.png"
          alt=""
        />
        <img
          v-else
          class="notice-img"
          src="@/assets/images/xmxx/中标候选人公示3.png"
          alt=""
        />
        <span>中标候选人公示</span>
      </div>
      <div
        class="notice-item"
        :class="{
          'can-view': isLbCanView,
          active: noticeType === noticeTypeMap.ZBJG,
        }"
        @click="isLbCanView && selectNoticeType(noticeTypeMap.ZBJG)"
      >
        <img
          v-if="noticeType === '4'"
          class="notice-img"
          src="@/assets/images/xmxx/中标流标公告1.png"
          alt=""
        />
        <img
          v-else-if="isLbCanView"
          class="notice-img"
          src="@/assets/images/xmxx/中标流标公告2.png"
          alt=""
        />
        <img
          v-else
          class="notice-img"
          src="@/assets/images/xmxx/中标流标公告3.png"
          alt=""
        />
        <span>结果公告</span>
      </div>
    </div>
    <el-table
      v-if="detailList.length > 1"
      class="detail-table"
      :data="detailList"
      fit
      :header-cell-style="headerCellStyle"
      :cell-style="cellStyle"
    >
      <el-table-column label="项目名称" min-width="180">
        <template slot-scope="scope">
          <span class="text-cut" :title="scope.row.gonggaoTitle">{{
            scope.row.gonggaoTitle
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="gonggaoFbstartDateStr"
        label="公告日期"
        width="180"
      />
      <el-table-column label="操作" width="120">
        <template slot-scope="{ row }">
          <el-button
            type="primary"
            plain
            size="small"
            class="select-btn"
            :class="{ 'is-active': row.infoid === detailInfo.infoid }"
            @click="changeItem(row)"
            >选中查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 详情 -->
    <div class="detail-content">
      <div class="detail-content-header">
        <p class="fs-20">{{ detailInfo.gonggaoTitle }}</p>
        <p class="color-999 mt-20">
          发布时间：{{ detailInfo.gonggaoFbstartDateStr }}
        </p>
      </div>
      <div class="detail-content-body" v-html="detailInfo.gonggaoContent" />
    </div>
  </div>
</template>

<script>
import purchaseApi from "@/api/purchase";
import { INFO_TYPE_OPTIONS, SELECT_OPTION_CONFIG } from "@/utils/constant";
export default {
  name: "",
  components: {},
  props: {
    baseInfo: {
      type: Object,
      default: () => {},
    },
    sectionId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      noticeType: "",
      isZbCanView: false,
      isCqCanView: false,
      isHxCanView: false,
      isLbCanView: false,
      typeMap: {
        [INFO_TYPE_OPTIONS.ZBGG[SELECT_OPTION_CONFIG.CODE]]:
          "purchaseNoticeProcessType",
        [INFO_TYPE_OPTIONS.BGGG[SELECT_OPTION_CONFIG.CODE]]:
          "changeNoticeProcessType",
        [INFO_TYPE_OPTIONS.ZBHXRGS[SELECT_OPTION_CONFIG.CODE]]:
          "candidateNoticeProcessType",
        [INFO_TYPE_OPTIONS.ZBJG[SELECT_OPTION_CONFIG.CODE]]:
          "resultNoticeProcessType",
      },
      detailList: [],
      detailInfo: {},
    };
  },
  // 监听属性 类似于data概念
  computed: {
    noticeTypeMap() {
      return {
        ZBGG: INFO_TYPE_OPTIONS.ZBGG[SELECT_OPTION_CONFIG.CODE],
        BGGG: INFO_TYPE_OPTIONS.BGGG[SELECT_OPTION_CONFIG.CODE],
        ZBHXRGS: INFO_TYPE_OPTIONS.ZBHXRGS[SELECT_OPTION_CONFIG.CODE],
        ZBJG: INFO_TYPE_OPTIONS.ZBJG[SELECT_OPTION_CONFIG.CODE],
      };
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.isZbCanView = this.baseInfo.hasPurchaseNotice;
    this.isCqCanView = this.baseInfo.hasChangeNotice;
    this.isHxCanView = this.baseInfo.hasCandidateNotice;
    this.isLbCanView = this.baseInfo.hasResultNotice;
    this.noticeType = this.getDefaultNoticeType();
    this.getDetail();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 方法集合
  methods: {
    getDefaultNoticeType() {
      const isCanViewMap = {
        [INFO_TYPE_OPTIONS.ZBGG[SELECT_OPTION_CONFIG.CODE]]: this.isZbCanView,
        [INFO_TYPE_OPTIONS.BGGG[SELECT_OPTION_CONFIG.CODE]]: this.isCqCanView,
        [INFO_TYPE_OPTIONS.ZBHXRGS[SELECT_OPTION_CONFIG.CODE]]:
          this.isHxCanView,
        [INFO_TYPE_OPTIONS.ZBJG[SELECT_OPTION_CONFIG.CODE]]: this.isLbCanView,
      };
      const queryNoticeType = this.$route.query.noticeType;
      if (queryNoticeType && isCanViewMap[queryNoticeType])
        return queryNoticeType;
      if (this.isZbCanView)
        return INFO_TYPE_OPTIONS.ZBGG[SELECT_OPTION_CONFIG.CODE];
      if (this.isCqCanView)
        return INFO_TYPE_OPTIONS.BGGG[SELECT_OPTION_CONFIG.CODE];
      if (this.isHxCanView)
        return INFO_TYPE_OPTIONS.ZBHXRGS[SELECT_OPTION_CONFIG.CODE];
      if (this.isLbCanView)
        return INFO_TYPE_OPTIONS.ZBJG[SELECT_OPTION_CONFIG.CODE];
    },
    // 获取详情
    getDetail() {
      const params = {
        infoId: this.baseInfo.infoid,
        sectionId: this.sectionId,
        processType: this.baseInfo[this.typeMap[this.noticeType]],
      };
      console.log(params);
      purchaseApi.detail(params).then((res) => {
        console.log("详情", res);
        if (res.code === 0) {
          const data = res.data || [];
          this.detailList = data;
          this.detailInfo = data[0];
          this.$emit("setTitle", data[0].gonggaoTitle);
          this.$store.commit(
            "permission/SET_DETAIL_TITLE",
            this.baseInfo.gonggaoTitle
          );
        }
      });
    },
    changeItem(data) {
      this.detailInfo = data;
    },
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      const str =
        "background-color: #f9f9f9;padding: 8px 0;text-align: center;";
      return str;
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let str = "padding: 10px 0;";
      if (columnIndex === 2) {
        str += "display: flex;justify-content: center;";
      }
      return str;
    },
    updateUrlWithoutReload(newPath, newQuery) {
      const url = new URL(window.location.href);

      if (newPath) {
        url.pathname = newPath;
      }

      if (newQuery) {
        Object.keys(newQuery).forEach((key) => {
          url.searchParams.set(key, newQuery[key]);
        });
      }
      // 使用 replaceState 更新 URL 而不触发页面刷新
      window.history.replaceState({}, "", url.href);
    },
    // 选择类别
    selectNoticeType(type) {
      if (type !== this.noticeType) {
        this.noticeType = type;
        this.updateUrlWithoutReload(
          this.$route.path,
          Object.assign(this.$route.query, { noticeType: type })
        );
        this.getDetail();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  padding-bottom: 20px;
}
.detail-header {
  border: 1px solid #ddd;
  background-color: #fff;
  .title {
    height: 94px;
    line-height: 94px;
    text-align: center;
    font-size: 26px;
    font-weight: bold;
  }
  .detail-info {
    border-top: 1px solid #ddd;
    padding: 30px 0;
    font-size: 16px;
    .detail-info-item {
      flex: 1;
      width: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      .application-btn {
        width: 90px;
        height: 32px;
        border-radius: 0;
        padding: 0;
        margin-top: 14px;
        &.is-disabled {
          background-color: #ddd;
          border-color: #ddd;
        }
      }
    }
    .detail-info-item + .detail-info-item {
      border-left: 1px solid #ddd;
    }
  }
}
.notice-list {
  height: 100px;
  margin-top: 20px;
  border: 1px solid #ddd;
  padding: 0 37px;
  background-color: #fff;
  .notice-item {
    width: 250px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
    font-size: 20px;
    color: #999;
    cursor: not-allowed;
    img {
      width: 25px;
      height: 25px;
      margin-right: 10px;
    }
  }
  .can-view {
    cursor: pointer;
    color: $--color-primary;
  }
  .active {
    cursor: pointer;
    background: $--color-primary;
    color: #fff;
  }
}
.detail-table {
  margin-top: 20px;
  border: 1px solid #ddd;
  border-bottom: 0;
  &::before {
    height: 0;
  }
  .select-btn {
    width: 70px;
    height: 24px;
    padding: 0;
    text-align: center;
    border-radius: 0;
    &.is-active {
      background-color: $--color-primary;
      color: #fff;
    }
  }
}
.detail-content {
  background-color: #fff;
  padding: 0 20px;
  border: 1px solid #ddd;
  margin-top: 20px;
  .detail-content-header {
    height: 136px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>
